import i18next from "i18next";
import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

export const i18n = i18next.init({
  initImmediate: false,
  defaultNS: "default",
  fallbackLng: "en",
  resources: {
    en: {default: en},
    es: {default: es},
    fr: {default: fr}
  }
});

/**
 * Switch the active i18next language so `t()` resolves UI strings in the
 * requested locale. No-op when the language is already active.
 *
 * Resources for every supported locale are preloaded in `init()` above and no
 * async backend is configured, so (with `initImmediate: false`) the change
 * applies synchronously — the new language is live before this returns, which
 * lets consumers re-render with translated text in the same update cycle.
 */
export function setLanguage(language: string): void {
  if (i18next.language !== language) {
    void i18next.changeLanguage(language);
  }
}
